import { GridColDef } from "@mui/x-data-grid";

export const dataGridColumns: GridColDef[] = [
  { field: "nameUN", headerName: "Empresa", width: 130 },
  { field: "nameUP", headerName: "Finca", width: 130 },
  { field: "identificationNumber", headerName: "No Identificación", type: "number", width: 130 },
  { field: "fullName", headerName: "Nombre", width: 130 },
  { field: "eMail", headerName: "Email", width: 130 },
  { field: "surveyLastUpdate", headerName: "Ultima actualización", width: 130 },
  { field: "noSurvey", headerName: "Número de encuestas", type: "number", width: 130 },
  { field: "completedSurvey", headerName: "Fecha encuesta completada", width: 130 },
  { field: "surveyStatus", headerName: "Estado encuesta", width: 130 },
  { field: "position", headerName: "Página completada", width: 130 },
  { field: "percentage", headerName: "Porcentaje completado", type: "number", width: 130 },
];

export const authRequest = {
  scopes: ["User.Read"],
};
